<template>
  <div>
    <ModalHeader
      :handleClose="handleClose"
      headerText="Please add payment information to continue using JumpCloud"
      :showClose="true"
    />
    <PaymentsWrapper
      :location="$options.modalLocation"
      @cancelled="handleClose"
      @error="handleError"
      @success="handleNextStep"
    />
  </div>
</template>

<script>
import * as Constants from 'client/util/Constants';
import { eventLocations } from 'client/GrowthEngineering/utilities/GrowthConstants';
import { notify } from 'client/util';
import ModalEventBus from 'components/Modal/ModalEventBus';
import ModalHeader from 'components/Modal/ModalComponents/ModalHeader.vue';
import PaymentStepMixin from 'client/Payments/mixins/PaymentStepMixin';
import PaymentsWrapper from 'client/Payments/PaymentsWrapper.vue';

const { error } = Constants.default;

const {
  accountBillingFormModal,
} = eventLocations;

export default {
  name: 'AccountBillingFormModal',

  components: {
    ModalHeader,
    PaymentsWrapper,
  },

  mixins: [PaymentStepMixin],

  modalLocation: accountBillingFormModal,

  methods: {
    handleClose() {
      ModalEventBus.close();
    },

    handleError(message) {
      notify(error, message);
    },
  },
};
</script>
